import React, { useState, useEffect } from 'react';
import Modal from './Modal';

const Calendar = ({ markedDates }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedYear, setSelectedYear] = useState(2025); // Default to 2025

    const openModal = (date) => {
        let newDate = date.split('/');
        if (newDate[0].length === 1) {
            newDate[0] = '0' + newDate[0];
        }
        let formattedDate = newDate.join('/');
        if (formattedDate) {
            setSelectedDate(formattedDate);
            setModalIsOpen(true);
        }
    };

    const closeModal = () => {
        setSelectedDate(null);
        setModalIsOpen(false);
    };

    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const daysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();

    const generateCalendar = (year, month) => {
        const firstDay = new Date(year, month, 1).getDay();
        const totalDays = daysInMonth(year, month);
        const calendar = [];
        let dayCount = 1;
        for (let i = 0; i < 6; i++) {
            const week = [];
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDay) {
                    week.push(null);
                } else if (dayCount <= totalDays) {
                    week.push(dayCount++);
                }
            }
            calendar.push(week);
        }
        return calendar;
    };

    const generateYearCalendar = (year) => {
        return Array.from({ length: 12 }, (_, month) => generateCalendar(year, month));
    };

    const [yearCalendarData2024, setYearCalendarData2024] = useState(generateYearCalendar(2024));
    const [yearCalendarData2025, setYearCalendarData2025] = useState(generateYearCalendar(2025));

    useEffect(() => {
        setYearCalendarData2024(generateYearCalendar(2024));
        setYearCalendarData2025(generateYearCalendar(2025));
    }, [markedDates]);

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    marginBottom: "1rem",
                    fontSize: "1.2rem",

                }}
            >
                <label>Select Year: </label>
                <select
                    style={{
                        padding: "5px",
                        margin: "0 1rem",
                        fontSize: "1rem",
                    }}
                    value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
                    <option value={2024}>2024</option>
                    <option value={2025}>2025</option>
                </select>
            </div>

            {selectedYear === 2024 && (
                <div>
                    <h1>2024 Calendar</h1>
                    <CalendarGrid
                        year={2024}
                        yearCalendarData={yearCalendarData2024}
                        markedDates={markedDates}
                        openModal={openModal}
                    />
                </div>
            )}

            {selectedYear === 2025 && (
                <div>
                    <h1>2025 Calendar</h1>
                    <CalendarGrid
                        year={2025}
                        yearCalendarData={yearCalendarData2025}
                        markedDates={markedDates}
                        openModal={openModal}
                    />
                </div>
            )}

            {selectedDate && (
                <Modal
                    isOpen={modalIsOpen}
                    closeModal={closeModal}
                    data={markedDates.find(dateData => dateData.date === selectedDate)}
                />
            )}
        </div>
    );
};

const CalendarGrid = ({ year, yearCalendarData, markedDates, openModal }) => {
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return (
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
            {yearCalendarData.map((monthCalendar, monthIndex) => (
                <div key={monthIndex} style={{ padding: '15px' }}>
                    <h2>{monthNames[monthIndex]} {year}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Sun</th>
                                <th>Mon</th>
                                <th>Tue</th>
                                <th>Wed</th>
                                <th>Thu</th>
                                <th>Fri</th>
                                <th>Sat</th>
                            </tr>
                        </thead>
                        <tbody>
                            {monthCalendar.map((week, weekIndex) => (
                                <tr key={weekIndex}>
                                    {week.map((day, dayIndex) => {
                                        let date = `${day}/${(monthIndex + 1).toString().padStart(2, '0')}/${year}`;
                                        let formattedDate = date.split('/').map((val, i) => (i === 0 && val.length === 1 ? '0' + val : val)).join('/');
                                        let backgroundColor = 'white';
                                        let color = 'black';

                                        markedDates.forEach(marked => {
                                            if (marked.date === formattedDate) {
                                                if (marked.totalPoints === 0) {
                                                    backgroundColor = '#000';
                                                } else if (marked.totalPoints < 5) {
                                                    backgroundColor = '#427dff';
                                                } else if (marked.totalPoints < 10) {
                                                    backgroundColor = '#4caf52';
                                                } else if (marked.totalPoints < 20) {
                                                    backgroundColor = '#ff4242';
                                                } else if (marked.totalPoints < 30) {
                                                    backgroundColor = '#ff9700';
                                                } else {
                                                    backgroundColor = '#cf4f7b';
                                                }
                                                color = 'white';
                                            }
                                        });

                                        return (
                                            <td key={dayIndex}
                                                style={{
                                                    border: '1px solid',
                                                    padding: '5px',
                                                    background: backgroundColor,
                                                    color: color,
                                                    borderRadius: '5px',
                                                    cursor: 'pointer',
                                                }}
                                                onClick={() => openModal(date)}
                                            >
                                                {day !== null && <span>{day}</span>}
                                            </td>
                                        );
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default Calendar;
